import {Vnode} from 'mithril';
import app from 'flarum/forum/app';
import {extend} from 'flarum/common/extend';
import EditUserModal from 'flarum/common/components/EditUserModal';
import Alert from 'flarum/common/components/Alert';
import User from 'flarum/common/models/User';

const translationPrefix = 'kilowhat-wordpress.forum.edit-user-modal.';

export default function () {
    extend(EditUserModal.prototype, 'fields', function (items) {
        const user: User = this.attrs.user;

        if (!user.attribute('kilowhatWordpressIsLinked')) {
            return;
        }

        items.add('kilowhat-wordpress-warning', m('.Form-group', Alert.component({
            dismissible: false,
        }, [
            app.translator.trans(translationPrefix + 'warning'),
            ' ',
            m('a.Button', {
                href: user.attribute('kilowhatWordpressEditLink'),
                target: '_blank',
                rel: 'noopener',
            }, app.translator.trans(translationPrefix + 'edit_in_wordpress')),
        ] as any)), 100);

        if (items.has('email')) {
            const emailField = items.get('email') as Vnode;

            if (Array.isArray(emailField.children)) {
                // Only make field disabled if we don't show fields
                if (!this.kilowhatWordpressShowFields) {
                    (emailField.children as Vnode[]).forEach(formGroupChild => { // One child of the .Form-group will be a simple div
                        if (formGroupChild && Array.isArray(formGroupChild.children)) {
                            (formGroupChild.children as Vnode<any>[]).forEach(divChild => { // One child of this div will be the input
                                if (divChild && divChild.tag === 'input') {
                                    if (!divChild.attrs) {
                                        divChild.attrs = {};
                                    }
                                    divChild.attrs.disabled = true;
                                }
                            });
                        }
                    });
                }

                emailField.children.push(m('p.helpText', app.translator.trans(translationPrefix + 'should_not_edit_email', {
                    a: m('a', {
                        onclick: () => {
                            this.kilowhatWordpressShowFields = true;
                            this.kilowhatWordpressUnlink = true;
                        },
                    }),
                })));
            }
        }

        if (!this.kilowhatWordpressShowFields && items.has('password')) {
            const passwordField = items.get('password') as Vnode;

            if (Array.isArray(passwordField.children)) {
                (passwordField.children as Vnode[]).forEach(formGroupChild => { // One child of the .Form-group will be a simple div
                    if (formGroupChild && Array.isArray(formGroupChild.children)) {
                        (formGroupChild.children as Vnode[]).forEach(divChild => { // One child of the div will be a label
                            if (divChild && divChild.tag === 'label' && Array.isArray(divChild.children)) {
                                (divChild.children as Vnode<any>[]).forEach(labelChild => { // One child of the label will be a checkbox
                                    if (labelChild && labelChild.tag === 'input') { // checkbox
                                        if (!labelChild.attrs) {
                                            labelChild.attrs = {};
                                        }
                                        labelChild.attrs.disabled = true;
                                    }
                                });
                            }
                        });
                    }
                });
            }
        }

        if (this.kilowhatWordpressShowFields) {
            items.add('kilowhat-wordpress-unlink', m('.Form-group', [
                m('label.checkbox', [
                    m('input', {
                        type: 'checkbox',
                        onchange: (event: Event) => {
                            this.kilowhatWordpressUnlink = (event.target as HTMLInputElement).checked;
                        },
                        checked: this.kilowhatWordpressUnlink,
                    }),
                    ' ',
                    app.translator.trans(translationPrefix + 'unlink'),
                ]),
                m('p.helpText', app.translator.trans(translationPrefix + 'unlink_help')),
            ]), 25);
        }
    });

    extend(EditUserModal.prototype, 'data', function (data: any) {
        if (this.kilowhatWordpressUnlink) {
            data.kilowhatWordpressUnlink = true;
        }
    });

    //TODO: add warning when deleting
}
